import React from 'react'
import { isActionAllowed, makeText } from '../../../util'

import './NeutralButtons.css'

const NeutralButtons = ({
  child,
  vendors,
  value,
  toggleCategory,
  settings,
  dev,
  language,
  toggleStack,
  style,
}) => {
  let { enabled } = value;
  if (enabled !== null) {
    if (value.isNegative) {
      enabled = !enabled;
    }
  }

  const {
    neutralButtonBackgroundColor,
    neutralButtonFontColor,
    onButtonBackgroundColor,
    onButtonFontColor,
    offButtonBackgroundColor,
    offButtonFontColor,
  } = settings;

  const toggleOn = (e) => {
    e.stopPropagation();

    if (value.childCategories) {
      toggleStack(e, value, true);
    } else {
      toggleCategory(e, value._id, value.isNegative ? false : true);
    }
  }

  const toggleOff = (e) => {
    e.stopPropagation();

    if (value.childCategories) {
      toggleStack(e, value, false);
    } else {
      toggleCategory(e, value._id, value.isNegative ? true : false);
    }
  }

  const acceptButtonStyles = {
    background: enabled === true ? onButtonBackgroundColor : neutralButtonBackgroundColor,
    color: enabled === true ? onButtonFontColor : neutralButtonFontColor,
  }

  const rejectButtonStyles = {
    background: enabled === false ? offButtonBackgroundColor : neutralButtonBackgroundColor,
    color: enabled === false ? offButtonFontColor : neutralButtonFontColor,
  }

  return (
    <div className="pur-buttons-container" style={style}>
      <button
        style={acceptButtonStyles}
        aria-pressed={enabled}
        onClick={toggleOn}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleOn(e)}
      >
        {makeText(dev, settings, 'onButtonText', language)}
      </button>
      <button
        style={rejectButtonStyles}
        aria-pressed={enabled === false}
        onClick={toggleOff}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleOff(e)}
      >
        {makeText(dev, settings, 'offButtonText', language)}
      </button>
    </div>
  )
}

export default NeutralButtons